import { api } from "./config/axios";

const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;

export class API {
    route: string;

    constructor(endpoint: string) {
        this.route = endpoint;
    }

    get = async (id: string) => {
        const response = await api.request({
            url: `/${this.route}/${id}`,
            method: 'GET',
        })

        return response;
    }

    getAll = async (params?: any) => {
        const response = await api.request({
            url: `/${this.route}/`,
            method: 'GET',
            params: params
        })

        return response;
    }

    patch = async (id: any, data: any) => {
        const response = await api.request({
            url: `/${this.route}/${id}/`,
            method: 'PATCH',
            data: data
        })

        return response;
    }

    post = async (data: any) => {
        const response = await api.request({
            url: `/${this.route}/`,
            method: 'POST',
            data: data
        })

        return response;
    }

    delete = async (id: string) => {
        const response = await api.request({
            url: `/${this.route}/${id}/`,
            method: 'DELETE'
        })

        return response;
    }

    request = async (config: any) => {
        // If the URL doesn't start with '/', prepend the route
        if (config.url && !config.url.startsWith('/')) {
            config.url = `/${this.route}/${config.url}`;
        } else if (config.url && config.url.startsWith('/')) {
            config.url = `/${this.route}${config.url}`;
        }

        const response = await api.request(config);
        return response;
    }
}